import axios from "axios";
import { COMPANY_API_CONTEXT_PATH } from "../apiContextPath";
import { getDefaultBuConfig } from "../apiUtil";
import { generateTraceId } from "./util/AxiosInstanceUtil";

const companyAxiosInstance = axios.create({
    baseURL: COMPANY_API_CONTEXT_PATH,
    timeout: getDefaultBuConfig<number>('REACT_APP_CONNECTION_TIME_OUT') ?? 20000,
    headers: { "Content-Type": "application/json" }
})

companyAxiosInstance.interceptors.request.use((config) => {
    // Modify the config object to include the token in the headers
    if (config.headers) {
        config.headers.Authorization = `Bearer ${localStorage.getItem("access_token_with_refresh")}`;
        config.headers.BuToken = `${localStorage.getItem("access_bu_token")}`;
        config.headers["X-Trace-Id"] = generateTraceId();
        config.headers["Selected-Printer"] = `${localStorage.getItem("CURRENT_PRINTER")}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

companyAxiosInstance.defaults.timeout = getDefaultBuConfig<number>('REACT_APP_CONNECTION_TIME_OUT') ?? 20000;

export default companyAxiosInstance;